import { CommonModule } from '@angular/common';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';

import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
registerLocaleData(localePt, 'pt');

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { AngularEditorModule } from '@kolkov/angular-editor';
import 'moment/locale/pt-br';
import {
  CURRENCY_MASK_CONFIG,
  CurrencyMaskConfig,
  CurrencyMaskModule,
} from 'ng2-currency-mask';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxMaskModule } from 'ngx-mask';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AsideComponent } from '../components/aside/aside.component';
import { BlankslateComponent } from '../components/blankslate/blankslate.component';
import { ContextLoadingComponent } from '../components/context-loading/context-loading.component';
import { DashboardHelpComponent } from '../components/dashboard-help/dashboard-help.component';
import { DocViewerComponent } from '../components/document-viewer/document-viewer.component';
import { InternalErrorComponent } from '../components/internal-error/internal-error.component';
import { LoadingComponent } from '../components/loading/loading.component';
import { SelectBankComponent } from '../components/select-bank/select-bank.component';
import { SocialMediaComponent } from '../components/social-media/social-media.component';
import { ViewerDocumentsComponent } from '../components/viewer-documents/viewer-documents.component';
import { LastDigitDirective } from '../directives/last-digit.directive';
import { DateMaskDirective } from '../date-mask.directive';
import { AuthInterceptorService } from '../interceptor/auth-interceptor.service';
import { ErrorInterceptorService } from '../interceptor/error-interceptor.service';
import { MyComponentComponent } from '../pages/operation/operation-document-viewer/documents/my-component.component';
import { ExpansionPanelComponent } from './../components/expansion-panel/expansion-panel.component';
import { AngularMaterialModule } from './angular-material.module';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'left',
  allowNegative: false,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.'
};

@NgModule({
  declarations: [
    BlankslateComponent,
    LoadingComponent,
    ContextLoadingComponent,
    DashboardHelpComponent,
    InternalErrorComponent,
    ViewerDocumentsComponent,
    MyComponentComponent,
    AsideComponent,
    SelectBankComponent,
    DocViewerComponent,
    LastDigitDirective,
    DateMaskDirective,
    ExpansionPanelComponent,
    SocialMediaComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    NgxMaskModule.forRoot(),
    CurrencyMaskModule,
    ReactiveFormsModule,
    FormsModule,
    AngularEditorModule,
    NgxMatSelectSearchModule,
    InfiniteScrollModule
  ],
  exports: [
    FormsModule,
    NgxMaskModule,
    CommonModule,
    CurrencyMaskModule,
    AngularMaterialModule,
    BlankslateComponent,
    LoadingComponent,
    ContextLoadingComponent,
    DashboardHelpComponent,
    ReactiveFormsModule,
    InternalErrorComponent,
    ViewerDocumentsComponent,
    MyComponentComponent,
    AngularEditorModule,
    AsideComponent,
    NgxMatSelectSearchModule,
    SelectBankComponent,
    DocViewerComponent,
    LastDigitDirective,
    DateMaskDirective,
    ExpansionPanelComponent,
    InfiniteScrollModule,
    SocialMediaComponent
  ],
  providers: [
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptorService,
      multi: true
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})
export class SharedModule { }
